<div class="overlay" role="status" aria-live="polite" aria-busy="true" aria-label="Loading">
    <svg class="spinner" viewBox="0 0 50 50" aria-hidden="true">
        <circle class="spinner__track" cx="25" cy="25" r="20" />
        <circle class="spinner__arc" cx="25" cy="25" r="20" />
    </svg>
</div>